import React, { useState, useEffect } from 'react';
import ReactSelect from '../../common/ReactSelect';
import { toast } from 'react-toastify';
import * as HELPER from '@src/config/helper';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FullPageLoader from '../../common/FullPageLoader';
import InputField from '../../common/InputField';
import ConfirmPopUp from '../../common/ConfirmPopUp';
import CurrencyInputField from '../../common/CurrencyInputField';
import { removeCurrencyFormatting } from '@src/config/helper';
import { ExpectedInstallmentDate } from '@src/common/DatePicker';
import InsuranceService from "@src/services/InsuranceService";
import { getMasterConfig, savePaymentProofs,getLeadPaymentDetails} from '@src/store/slices/insurance';
import { useParams } from 'react-router-dom';
import { AGENT_WEB, DOC_UPLOAD_VALIDATION, MAX_FILE_UPLOAD, STATUS_CODES } from "@src/config/constant";
import { isMobile } from "react-device-detect";


function PaymentAddEdit() {
    const dispatch: any = useDispatch();
    const [formData, setFormData] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false)
    const [previewImages, setPreviewImages] = useState<any>([]);
    const [imageSlider, setImageSlider] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [actionType, setActionType] = useState<any>('');
    const navigate = useNavigate();
    const commonState = useSelector((state: any) => state.insurance);
    // eslint-disable-next-line
    const [disableField, setDisableField] = useState<boolean>(false);
    const [showPaymentReference, setShowPaymentReference] = useState<any>([{ date_time: '', payment_ref_no: '', disabled: '' }]);
    // eslint-disable-next-line
    const [paymentRefArray, setPaymentRefArray] = useState<any>([]);
    // eslint-disable-next-line
    const [bulkPaymentOrigData, setBulkPaymentOrigData] = useState<any>({});
    
    const queryParams = useParams();
    const lead_id = queryParams.id

    useEffect(() => {
        if (Object.keys(commonState.common).length === 0) {
            dispatch(getMasterConfig());
        }
        // eslint-disable-next-line
    }, [commonState?.common, dispatch]);

    const paymentMethods = commonState.common?.payment_method;

    const getFormData = async () => {
        let postData: any = {};

        postData['payment_data'] = {
            payment_method: formData?.payment_method,
            amount: formData?.gross_premium
        };
        postData['insurance_details'] = [
            {
                "lead_id": formData.lead_id,
                "amount": formData.gross_premium,
                "total_fmv": formData.total_fmv_car
            }
        ];

        postData['payment_ref_date_time'] = [{
            date_time: formData?.date_time?.toISOString() || "",
            
        }];
        if(formData?.pending_payment_net_of_commission){
            postData['insurance_details'][0]['pending_amount'] = formData.pending_payment_net_of_commission
        }
        if(formData.payment_ref_no){
            postData['payment_ref_date_time'][0]['payment_ref_no'] = formData.payment_ref_no
        }

        postData['source'] = AGENT_WEB;
        return postData;
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        let data: any = await getFormData();

        if (await isFormValid(data)) {

            let paramObj = new FormData();
            let sortedRefsAccToImages:any = []
            Object.keys(previewImages || {}).forEach((key) => {
                (previewImages[key] || []).forEach((imageObj: any) => {
                    if (imageObj.file) {
                        paramObj.append('images', imageObj.file);
                    }
                    if(data.payment_ref_date_time[key]){
                        sortedRefsAccToImages.push(data.payment_ref_date_time[key]['payment_ref_no'])
                    }
                });
            });

            await InsuranceService.bulkPayment(data).then((res: any) => {
                if (res.data.status === STATUS_CODES['success']) {
                    toast.success(res.data.message);
                    if(previewImages?.[0]?.length > 0){
                    paramObj.append("payment_id", res?.data?.data?.id);
                    // eslint-disable-next-line
                    paramObj.append('source', "" + '6');
                    paramObj.append("payment_Ref_no", JSON.stringify(formData.payment_ref_no));
                    paramObj.append("sortedRefsAccToImages", JSON.stringify(sortedRefsAccToImages));
                    paramObj.append("insurance_details",JSON.stringify(data?.insurance_details));
                    savePaymentProofs(paramObj).then((resp: any) => {
                        if (resp && resp.status === STATUS_CODES['success']) {
                            setLoading(false);
                            toast.success(resp.message || resp?.data?.message);
                            setPaymentRefArray([]);

                        } else {
                            setLoading(false);
                        }
                    }).catch((err: Error) => { setLoading(false) })

                    }else{
                        setLoading(false);
                    }

                     navigate('/claim-list');
                } else {
                    setLoading(false);
                    toast.error(res?.message || res?.data?.message);
                }
            })


        } else {
            setLoading(false);
            toast.error('Please ensure all required fields are completed.');
        }

    }


    const isFormValid = async (data: any) => {
        //return false;
        let isValid = true;

        let updatedError: any = {}
        if (!data.payment_ref_date_time[0].date_time || data.payment_ref_date_time[0].date_time === "") {
            updatedError[`date_time`] = "Premium reference data & time is required";
            isValid = false;
        }

        if (!data.payment_data.payment_method || data.payment_data.payment_method === "") {
            updatedError[`payment_method`] = "payment method is required";
            isValid = false;
        }

        setErrors({ ...updatedError });
        return isValid;

    }


    const handleChange = (event: any, key: any, index: any = null) => {
        let value: any = '';
        let target = event?.target;
        if (key === 'date_time') {
            value = event || "";
            const newTenureArray: any = [...showPaymentReference];
            newTenureArray[index] = { ...newTenureArray[index], date_time: value };
            setShowPaymentReference(newTenureArray);
            errors[`date_time_${index}`] = '';

            setShowPaymentReference(newTenureArray);

        }

        else if (target) value = target?.value;
        else if (event) value = event.value;

        formData[key] = value;
        errors[key] = '';

        setErrors({ ...errors });
        setFormData({ ...formData });

    }


    const showImagePopup = (activeImg: number) => {
        setImageSlider(!imageSlider)
        // setActiveImageIndex(activeImg)
    }


    const handleFileInputChange = async (e: any, index: any) => {

        let selectedFiles = e.target.files;
        let validFiles: File[] = [];
        let previewImage: any = [];

        if ((selectedFiles.length + (previewImages[index]?.length || 0)) > MAX_FILE_UPLOAD) {
            toast.error("Maximum 5 Documents are allowed")
            return;
        }

        for (const file of selectedFiles) {
            let allowedExtensions = ['data:application/pdf', 'data:image/*']
            let base64PreviewImg: any = await HELPER.toBase64(file);
            let filetype = await HELPER.detectMimeType(base64PreviewImg, { allowedExtensions });
            let fileSize = file.size;

            if (!filetype) {
                toast.error("Please Select a valid file");
            } else if (fileSize < DOC_UPLOAD_VALIDATION['minSize'] || fileSize > DOC_UPLOAD_VALIDATION['maxSize']) {
                toast.error('File size should be between 25kb to 5mb');
            } else {
                validFiles.push(file);
                previewImage.push({ url: base64PreviewImg, type: file.type.split('/')[1], file: file });
                // Append docObj to newDocArray
                // send payment_ref no along with each image
                setPaymentRefArray((prev: any) => [
                    ...prev,
                    showPaymentReference[index].payment_ref_no
                ]);

                // setValidSelectedFiles()

            }
        }


        if (validFiles.length > 0) {
            setPreviewImages((prev: any) => ({ ...prev, [index]: [...(prev[index] || []), ...previewImage] }));
        }

        e.target.value = '';

        //errors['images'] = ''
        errors[`images_${index}`] = '';
        if (!showPaymentReference[index].date_time && !showPaymentReference[index].payment_ref_no) {
            errors[`images_${index}`] = '';
        }
        setErrors(errors)

    }

    const handleImageDelete = (imageToDelete: any, index: number) => {
        setShowConfirmation(true); // Show confirmation popup
        setConfirmationMessage("Are you sure you want to delete this image?");
        setActionType(() => () => {
            setPreviewImages((prev: any) => {
                const updatedImages = prev[index]?.filter(
                    (img: any) => img.url !== imageToDelete.url
                );
                return { ...prev, [index]: updatedImages };
            });
            setShowConfirmation(false); // Hide confirmation popup
        });
    };
    

    const confirmYes = () => {
        if (actionType) {
            actionType(); // Execute the deletion action
        }
    }

    const confirmNo = () => {
        setShowConfirmation(false);
        setActionType(null);
    }

    useEffect(() => {
        getLeadPaymentDetails({ lead_id: lead_id }).then((resp: any) => {
            if (resp && resp.status === STATUS_CODES['success']) {
                //setLeadData(resp.data);
                setFormData(resp.data); // add value here
                setLoading(false);
                
            } else {
                setLoading(false);
            }
        }).catch((err: Error) => { setLoading(false) })
    },[lead_id]);

    return (
        <>
            <div className="container-fluid">
                <FullPageLoader show={loading} />

                <div className="top-heading financer-lead-heding">
                    <div className='d-flex edit-approve-btn-top'>

                    </div>
                </div>

                <div className="rule-engine-menu-sec p-lg">
                    <h2>Payment Info</h2>

                    <br style={{ clear: 'both' }} />

                    <div className="row agency-payment-form">

                        <div className='form-select-bx col-md-4 col-xs-12 p-sm-b'>
                            <ReactSelect
                                options={paymentMethods ?? []}
                                value={formData && paymentMethods?.filter((v: any) => +v.value === +formData?.payment_method)} handleChange={(e: any) => handleChange(e, "payment_method")}
                                placeholder="Payment Method *"
                                fieldKey="payment_method"
                                errorField={errors?.payment_method ? errors?.payment_method : ''}
                                isDisabled={formData.isBulkPaymentFreezed || disableField} />
                        </div>

                        <div className='form-select-bx col-md-4 col-xs-12 p-sm-b'>
                            <fieldset className="" key={`payment_premium_amount`}>
                                <div className="material">

                                    <CurrencyInputField
                                        inputProps={{
                                            id: "",
                                            name: "payment_premium_amount",
                                            className: "form-input",
                                            type: "text",
                                            value: removeCurrencyFormatting(formData.gross_premium) || removeCurrencyFormatting(formData.gross_premium) || 0,
                                            maxLength: "",
                                            placeholder: " ",
                                            disabled: true,
                                        }}
                                        onChange={(e: any) => handleChange(e, "payment_premium_amount")}
                                    />
                                    <label data-label={`Premium Amount`} className="form-label"> </label>

                                </div>
                            </fieldset>
                        </div>

                        <div className='form-select-bx col-md-4 col-xs-12 p-sm-b'>
                            <fieldset className="" key={`payment_pending_amount`}>
                                <div className="material">
                                    <CurrencyInputField
                                        inputProps={{
                                            id: "",
                                            name: "payment_pending_amount",
                                            className: "form-input",
                                            type: "text",
                                            value: removeCurrencyFormatting(formData.pending_payment_net_of_commission) || removeCurrencyFormatting(formData.pending_payment_net_of_commission) || 0,
                                            maxLength: "",
                                            placeholder: " ",
                                            disabled: true,
                                        }}
                                        onChange={(e: any) => handleChange(e, "payment_pending_amount")}
                                    />
                                    <label data-label={`Pending Amount`} className="form-label"> </label>

                                </div>
                            </fieldset>
                        </div>

                        {
                            showPaymentReference?.map((val: any, index: any) => (
                                <React.Fragment key={index}>
                                    <div className='form-select-bx col-md-4 col-xs-12 p-sm-b'>
                                        <fieldset className="date-picker-detail p-sm-b">
                                            <div className={(showPaymentReference[index].date_time) ? "active-label material animation-effect" : "material animation-effect "}>


                                                <ExpectedInstallmentDate
                                                    onChange={(e: Date) => handleChange(e, "date_time", index)}
                                                    selected={showPaymentReference?.[index]?.date_time !== '' ? new Date(showPaymentReference[index].date_time) : ""}
                                                    dateFormat="dd MMM, yyyy h:mm aa"
                                                    disabled={(formData.isBulkPaymentFreezed && bulkPaymentOrigData?.['payment_tenure_data']?.[index]?.['payment_ref_no']) || disableField || val.disabled}
                                                    installmentNumber={index + 1}
                                                    prevInstallmentDate={showPaymentReference?.[index - 1]?.date_time || null}
                                                    text={`Payment ${(formData?.payment_tenure) ? (index + 1) : ""} Date${index === 0 ? "*" : ""}`}
                                                    source="detailSection"
                                                    showTimeSelect={true}
                                                    minDateAgency={new Date((new Date().getFullYear() - 1) + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate())}
                                                />
                                                {
                                                    errors[`date_time`]
                                                        ?
                                                        <span className="error-txt">{errors[`date_time`]}</span>
                                                        :
                                                        ''
                                                }
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div className='form-select-bx col-md-4 col-xs-12 p-sm-b'>
                                        <fieldset className="" key={`payment_ref_no`}>
                                            <div className="material">
                                                <InputField
                                                    inputProps={{
                                                        id: `payment_ref_no`,
                                                        name: `payment_ref_no`,
                                                        className: "form-input",
                                                        type: "text",
                                                        //value: showPaymentReference[index].payment_ref_no || '',//[{ref:2,date},{ref:2}]
                                                        maxLength: "",
                                                        placeholder: " ",
                                                    }}
                                                    onChange={(e: any) => handleChange(e, "payment_ref_no")}
                                                />
                                                <label data-label={`Payment Reference`} className="form-label"></label>

                                            </div>
                                        </fieldset>
                                    </div>
                                </React.Fragment>

                            ))
                        }
                    </div>


                    {
                        showPaymentReference.map((val: any, index: any) => (
                            <React.Fragment key={index}>
                                <div className='upload-heading-text'>
                                    <h3>{`Upload Payment Proof `}</h3>
                                </div>



                                <div className='row p-lg-b'>
                                    {previewImages[index]?.length > 0 && previewImages[index].map((image: any, imgIndex: any) => (
                                        <div className="col-md-2 col-xs-4 p-lg-t" key={`doc-${imgIndex}`}>

                                            <div key={imgIndex} className="upload-image-proof">
                                                {
                                                    image?.type?.indexOf("pdf") !== -1
                                                        ?
                                                        <i className={`ic-${image?.type}-file icons-normal t-accent`} onClick={() => showImagePopup(index)} style={{ fontSize: "100px" }}></i>
                                                        :
                                                        <img src={image.url} alt={`preview-${index}`} className="upload-icn" onClick={() => showImagePopup(index)} />

                                                }

                                                {!(formData.isBulkPaymentFreezed && image.id && bulkPaymentOrigData?.['payment_tenure_data']?.[index]?.['payment_ref_no']) && !disableField && <div className="close-icn" onClick={() => handleImageDelete({ ...image, id: (image.id || index), type: (!image.id ? "new" : "old") }, index)}>
                                                    <i className="ic-clearclose"></i>
                                                </div>}
                                            </div>

                                        </div>
                                    ))
                                    }

                                    <div className="col-md-2 col-xs-4 p-lg-t">
                                        {
                                            (previewImages[index]?.length || 0) < MAX_FILE_UPLOAD &&
                                            <div className="add-document-proof">
                                                {
                                                    <input type="file" className="upload-image-input" name="documents" title=""
                                                        accept="image/*, application/pdf"
                                                        onChange={(e: any) => handleFileInputChange(e, index)} multiple disabled={disableField} />
                                                }
                                                <i className="ic-add"> </i>
                                                <span className='add-doc-text d-block'>Add Document</span>
                                            </div>
                                        }

                                        {
                                            errors[`images_${index}`]
                                                ?
                                                <span className="error-txt error-left">{errors[`images_${index}`]}</span>
                                                :
                                                ''
                                        }
                                    </div>

                                </div>
                            </React.Fragment>
                        ))
                    }


                    <div className={`btn-bottom btn-bottom-fixed ${
                        isMobile ? "t-center" : "t-left p-lg-t"
                    }`}>
                        <button className="btn-primary" onClick={handleSubmit} disabled={disableField}>
                            Submit Details
                        </button>
                    </div>

                </div>

                {showConfirmation === false ? ("") : (
                    <ConfirmPopUp
                        confirmNo={confirmNo}
                        confirmYes={confirmYes}
                        message={confirmationMessage} />
                )}


            </div>
        </>
    );
};

export default PaymentAddEdit;

